import { createElement, useState } from 'react';
import './index.scss';
import AddressListItem from './address-list-item';
const AddressList = ({ dataList, onClick = () => { }, onSelect, children, ...otherProps }) => {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const _otherProps = otherProps || {};
    const handleSelect = (index) => {
        setSelectedIndex(index);
        onSelect?.(index);
    };
    return (createElement("div", { className: "address-list", ..._otherProps }, dataList ? (dataList.map((item, index) => {
        return (createElement(AddressListItem, { key: index, onClick: () => handleSelect(index), selected: selectedIndex === index, onRemove: () => console.log('remove', index), onEdit: () => console.log('edit', index), ...item }, children));
    })) : (createElement("div", null, "\u6682\u65E0\u6570\u636E"))));
};
AddressList.displayName = 'AddressList';
export default AddressList;
